// Next statically analyzes the imports and ensures that the `next/headers` module is never imported on a client bundle.
//
// We know what we're doing though. We ensure at runtime that we never use the module unless we're on the server, so the
// static analysis is wrong.
//
// Fortunately, as a hack, we can get around it by importing them using the `export from` syntax, which the static
// analyzer does not detect, but Webpack is fine with it.
//
// So, we can use the export syntax here, and then import them normally in the main file.
export * from 'next/headers';
